import { getDevErrorPageState } from "places-diagnostics";

import { getCollaboratorsWithLocation } from "./services/getCollaboratorsWithLocation";
import getPlace from "./services/getPlace";
import { getPlacesBuildingList } from "./services/getPlacesBuildingList";

import type { CollaboratorScheduleWithLocation, Collaborator, } from "hybridspace-common/lib/serviceTypes";
import type { DateRange } from "owa-datetime-utils";
import type { CollaboratorGroup, Place } from "owa-graph-schema";
export default class PlacesExploreClient {
    /**
     * Get all the places of type building
     */
    async getPlaces(): Promise<Map<string, Place>> {
        // Manually throw an error to test error handling
        let places;
        try {
            if (getDevErrorPageState() === "Places") {
                throw new Error("PlacesFailed: could not get places");
            }
            places = await getPlacesBuildingList();
        }
        catch (error) {
            /* eslint-disable owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
             * Error constructor names can only be a string literals.
             *	> Error constructor names can only be a string literals. Use the diagnosticInfo to add custom data. */
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'string | undefined'.
            // @ts-expect-error
            throw new Error(error);
            /* eslint-enable owa-custom-rules/no-error-dynamic-event-names  */
        }
        return places;
    }
    
    /**
     * Get the Place for a specific building
     */
    async getPlaceFromBuildingId(buildingId: string): Promise<Place> {
        // Manually throw an error to test error handling
        let place;
        try {
            place = await getPlace(buildingId);
        }
        catch (error) {
            /* eslint-disable owa-custom-rules/no-error-dynamic-event-names -- (https://aka.ms/OWALintWiki)
             * Error constructor names can only be a string literals.
             *	> Error constructor names can only be a string literals. Use the diagnosticInfo to add custom data. */
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS2345: Argument of type 'unknown' is not assignable to parameter of type 'string | undefined'.
            // @ts-expect-error
            throw new Error(error);
            /* eslint-enable owa-custom-rules/no-error-dynamic-event-names  */
        }
        return place;
    }
    
    /**
     * Get collaborators schedule with building location
     */
    async getCollaboratorsLocations(dateRange: DateRange, groupsToInclude?: CollaboratorGroup[]): Promise<{
        collaboratorScheduleWithLocation: CollaboratorScheduleWithLocation[];
        savedCollaborators: Collaborator[];
        suggestedCollaborators: Collaborator[];
    }> {
        let result;
        try {
            result = await getCollaboratorsWithLocation(dateRange, groupsToInclude);
        }
        catch (error) {
            // Errors resulting from enabling useUnknownInCatchVariables
            // TS18046: 'error' is of type 'unknown'.
            // @ts-expect-error
            if (error.message === "Collaborators not found in getCollaboratorsWithLocation") {
                throw new Error("Collaborators not found");
            }
            else {
                throw new Error("Schedule with location not found");
            }
        }
        return {
            collaboratorScheduleWithLocation: result.collaboratorScheduleWithLocation,
            savedCollaborators: result.savedCollaborators,
            suggestedCollaborators: result.suggestedCollaborators,
        };
    }
}
